/**
 * Sadly we cannot use rem in breakpoints, as some browsers will always use
 * 16px as the base, and some will use the font-size set on the html tag (10px).
 */
export const breakpoints = {
  minPhone: '375px',
  minTablet: '768px',
  minDesktop: '1024px'
}
